import Vue from 'vue'
import Vuex from 'vuex'
import auth from './modules/auth'
import user from './modules/user'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    snackbar_activate: false,
    snackbar_message: '',
    snackbar_color: 'success',
    language: 'es',
    rfid: null,
    guardhouseName: localStorage.getItem('guardhouse_name') !== null ? localStorage.getItem('guardhouse_name') : null,
    bandQr: localStorage.getItem('banderaQR') !== null ? localStorage.getItem('banderaQR') : false,
    bandCam: localStorage.getItem('banderaCam') !== null ? localStorage.getItem('banderaCam') : false,
    qrDevices: localStorage.getItem('qr_devices') !== null ? JSON.parse(localStorage.getItem('qr_devices')) : [],
    camDevices: localStorage.getItem('cam_devices') !== null ? JSON.parse(localStorage.getItem('cam_devices')) : [],
    studentsList: localStorage.getItem('listaEstudiantes') !== null ? JSON.parse(localStorage.getItem('listaEstudiantes')) : [],
  },
  getters: {
    getRfid: state => state.rfid,
    getGuardhouseName: state => state.guardhouseName
  },
  mutations: {
    snackbar_change_message (state, aMessage) {
      state.snackbar_message = aMessage
    },
    snackbar_activate_false (state) {
      state.snackbar_activate = false
    },
    snackbar_activate_true (state) {
      state.snackbar_activate = true
    },
    snackbar_change_color (state, aColor) {
      state.snackbar_color = aColor
    },
    changeLanguage (state, aLanguage) {
      state.language = aLanguage
    },
    setStudentsList (state, list) {
      state.studentsList = JSON.parse(list)
    },
    setRFID (state, aRfid) {
      state.rfid = aRfid
    },
    setGuardhouseName (state, aGuardhouseName) {
      state.guardhouseName = aGuardhouseName
    },
    enableBandQr (state, enable) {
      state.bandQr = enable
    },
    enableBandCam (state, enable) {
      state.bandCam = enable
    },
    setQRDevices (state, devices) {
      state.qrDevices = devices
    },
    setCamDevices (state, devices) {
      state.camDevices = devices
    },
    setPhotos (state, photos) {
      state.photosCamera = photos
    }

  },
  actions: {
  },
  modules: {
    user,
    auth
  }
})
